import {
  Directive, HostBinding, EventEmitter, OnDestroy, ContentChildren, ElementRef, QueryList, AfterContentInit
} from '@angular/core';
import { takeUntil, startWith } from 'rxjs/operators';

import { BreakpointsService } from '@sondermind/utilities/services';

import { ButtonDirective } from './button.directive';

@Directive({
  selector: '[sondermind-button-row]',
  standalone: false
})

/**
 * @deprecated This should not be used. Instead, consider using IrisButton and IrisButtonContainer where appropriate.
 */
export class ButtonRowDirective implements OnDestroy, AfterContentInit {
  destroyed$ = new EventEmitter<void>();

  constructor(
    breakpoints: BreakpointsService
  ) {
    breakpoints.isMobile$
      .pipe(takeUntil(this.destroyed$))
      // eslint-disable-next-line no-return-assign
      .subscribe((m) => this.isMobile = m);
  }

  @HostBinding('class.sondermind-button-row')
    addClass = true;

  @HostBinding('attr.data-mobile')
    isMobile: boolean;

  @ContentChildren(ButtonDirective, { read: ElementRef })
    buttons: QueryList<ElementRef<any>>;

  @HostBinding('attr.data-count')
    childCount = 1;

  ngAfterContentInit(): void {
    this.buttons.changes
      .pipe(
        takeUntil(this.destroyed$),
        startWith(this.buttons.length)
      )
      // eslint-disable-next-line no-return-assign
      .subscribe(() => this.childCount = this.buttons && this.buttons.length);
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
  }
}
